module.exports = __webpack_public_path__ + "static/media/29DUNON5.cb44479b.jpg";